import { CheckCircle2 } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

export default function Bevestiging() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div data-testid="bevestiging-card" className="bg-card border border-border rounded-2xl p-10 max-w-lg text-center">
          <CheckCircle2 size={48} className="mx-auto mb-5 text-primary" />
          <h1 className="font-heading text-3xl font-semibold">Aanvraag ontvangen!</h1>
          <p className="mt-3 text-muted-foreground leading-relaxed">
            Bedankt voor je reserveringsaanvraag. Daniëlle neemt contact met je op en stuurt je een offerte. Na akkoord is je reservering definitief en ontvang je een bevestiging per e-mail.
          </p>
          <div className="mt-7">
            <a href="/" className="inline-flex items-center justify-center bg-primary text-primary-foreground font-medium rounded-full px-6 py-3 hover:bg-primary-hover transition-colors">Terug naar home</a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
